import { Component, Input, OnInit } from '@angular/core';
import { AverageTicketVolume, TopSalesEntities } from '../../../../shared/models/EvoSalesPortalModel';
import { DashboardService } from '../../../../shared/services/dashboard.service';
import { HttpErrorResponse } from '@angular/common/http';
import { BindingContext } from '../../../../shared/models/BindingContext';
import { DashboardWidget } from '../../dashboard-interface';

@Component({
    selector: 'app-dashboard-top-perf',
    templateUrl: './dashboard-top-perf.component.html',
    styleUrls: ['./dashboard-top-perf.component.scss'],
    host: { 'class': 'col-md-6 col-lg-4' }
})
export class DashboardTopPerfComponent extends DashboardWidget implements OnInit {
    @Input() title: string;
    @Input() color = 'white';
    @Input() url: string;
    @Input() bindingContext: BindingContext;

    public topPerformers: Array<TopSalesEntities>;
    private dashboardError: string = "Error loading dashboard item, please contact support."

    constructor(private dashboardSvc: DashboardService) {
        super();
        this.topPerformers = new Array<TopSalesEntities>();
    }

    /**
     * Lifecycle event after inputs, get the data
     */
    ngOnInit() {
        this.getData();
    }

    /**
     * Fetch the top performers from the server
     */
    private getData() {
        this.bindingContext.beginGet();
        this.dashboardSvc.getTopPerformers().subscribe(
            resp => {
                this.bindingContext.endGet(true);
                this.topPerformers = resp;
            },
       
            (response: HttpErrorResponse) => {
                this.bindingContext.endGet();
                this.bindingContext.showAlert(BindingContext.alertType.danger, this.dashboardError, true);
            }
        );
    }

}
